function getBeltOpt (data) {

 // data = {
 //  xdata: [1, 2, 3, 4, 5, 6, 7, 8],
 //  ydata: [1, 5.7, 3, 21, 10.2, 20, 30, 102]
 // }
 let xData = data.xdata;
 let y1Data = data.ydata;

 let maxVal = 0; //最大值
 let maxVal_ = 0;
 let intVal = 7; //步长

 // 1. 遍历 dataList（图表需要展示的数据） 获取最大值
 data.ydata.forEach((res) => {
  let number = parseFloat(res);
  if (number > maxVal) {
   maxVal = number;
   maxVal_ = number;
  }
 });

 // 2. 最大值 向上取整
 maxVal = Math.ceil(maxVal);
 let n = maxVal.toString().length-1
 // 3. 最大值 被5整除，防止y轴步长出现小数
 if (maxVal % (intVal * 10 ** n) != 0) {
  maxVal = (Math.floor(maxVal / (intVal * 10 ** n)) + 1) * (intVal * 10 ** n)
 }

 y1Data.forEach((i, index) => {
  if (i == maxVal_) {
   y1Data[index] = {
    value: maxVal_,
    itemStyle: {
     barBorderRadius: [2, 2, 0, 0],
     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
      offset: 0,
      color: '#FFEDB6'
     },
     {
      offset: 1,
      color: '#EA7777'
     }
     ], false)
    }
   }
  }
 })
//  console.log('y1Data', y1Data)
 return {
  backgroundColor: "transparent",
  tooltip: {
   show: true,
   trigger: 'axis',
   backgroundColor: 'rgba(4, 21, 39, 1)',
   borderWidth: 0,
   textStyle: {
    color: '#fff'
   }
  },
  legend: {
   show: false,
   icon: 'rect',
   itemWidth: 14,
   itemHeight: 4,
   right: '2%',
   top: '8%',
   textStyle: {
    fontSize: 14,
    color: 'rgba(255,255,255,1)',
    padding: [2, 0, 0, 0]
   }
  },
  grid: {
   top: '0%',
   left: '0%',
   right: '0%',
   bottom: '0%',
   containLabel: true,
  },
  xAxis: [{
   type: 'category',
   axisLine: {
    show: true,
    lineStyle: {
     color: '#000',
     width: 2
    },
   },
   boundaryGap: ['4%', '0%'],
   axisLabel: {
    margin: 5,
    textStyle: {
     color: "#9FBAFD",
     fontSize: 12,
    },
   },
   axisTick: {
    show: false,
   },
   data: xData,
  }],
  yAxis: [{
   name: '单位：t',
   nameTextStyle: {
    fontSize: 14,
    color: "#9FBAFD",
    padding: [0, 0, 0, 20]
   },
   type: 'value',
   min: 0,
   max: maxVal,
   splitNumber: intVal,//分割成几段
   boundaryGap: [0, 1],
   splitLine: {
    // show: false,
    lineStyle: {
     color: '#000',
     width: 2,
     // type: 'dashed',
    }
   },
   axisLine: {
    // show: true,
    lineStyle: {
     color: '#000',
     width: 2
    }
   },
   axisLabel: {
    margin: 5,
    verticalAlign: "bottom",
    inside: false,
    lineHeight: 15,
    textStyle: {
     color: '#ADD8FF',
     fontSize: 10,
    },
   },
   axisTick: {
    show: false,
   },
  }],
  series: [{
   name: "运输量",
   type: 'bar',
   barMaxWidth: "30%",
   barWidth: 11,
   itemStyle: {
    barBorderRadius: [2, 2, 0, 0],
    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
     offset: 0,
     color: '#FCFFE9'
    },
    {
     offset: 1,
     color: '#77CDEA'
    }
    ], false)
   },
   data: y1Data
  }]
 }
}

export default getBeltOpt